import React, { useState, useEffect } from "react";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import axios from "axios";
import { useParams } from "react-router-dom";
import "./MobileSettings.css";
import Response_Loading_processing from "../../../../src/layout/Others/Response_Loading_processing";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import { IoImagesOutline } from "react-icons/io5";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import { useMyContext } from "../../../components/Provider/CommonProvider";

function EditSplashMobileSettings(props) {
  const { id } = useParams();
  const access_token = localStorage.getItem("access_token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const { fetchRequest, globalImageUplaodAPI } = useMyContext();
  const imageApi = globalImageUplaodAPI();

  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [formErrors, setFormErrors] = useState({
    splash: "",
    android: "",
    androidTv: "",
    lgTv: "",
    rokuTv: "",
    samsungTv: "",
    fireTv: "",
  });
  const [editUser, setEditUser] = useState({
    splash_image_url: "",
    andriod_splash_image_url: "",
    AndroidTv_splash_screen_url: "",
    LG_splash_screen_url: "",
    RokuTV_splash_screen_url: "",
    Samsung_splash_screen_url: "",
    Firetv_splash_screen_url: "",
  });

  const [selectedFiles, setSelectedFiles] = useState({
    splash: null,
    android: null,
    androidTv: null,
    lgTv: null,
    rokuTv: null,
    samsungTv: null,
    fireTv: null,
  });

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/Mobile-App-Setting/splash-screen-edit/${id}`,
        { headers }
      );
      setEditUser(response?.data?.splash_screen);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  // const handleFileChange = (field, file) => {
  //   if (!file) return;

  //   const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
  //   if (!allowedTypes.includes(file.type)) {
  //     alert('Please upload only image files (JPEG, PNG, WEBP, GIF)');
  //     return;
  //   }

  //   setSelectedFiles(prev => ({ ...prev, [field]: file }));
  // };

  const handleDelete = (field) => {
    setSelectedFiles(prev => ({ ...prev, [field]: null }));
  };

  const handleFileChange = (field, file) => {
    if (!file) return;

    const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
    if (!allowedTypes.includes(file.type)) {
      setFormErrors(prev => ({ ...prev, [field]: 'Please upload only image files (JPEG, PNG, WEBP, GIF)' }));
      return;
    }

    setFormErrors(prev => ({ ...prev, [field]: '' }));
    setSelectedFiles(prev => ({ ...prev, [field]: file }));
  };

  const handleUpdate = async () => {
    const formData = new FormData();
    formData.append("id", id);

    const fieldNameMap = {
      splash: "splash_image",
      android: "andriod_splash_image",
      androidTv: "AndroidTv_splash_screen",
      lgTv: "LG_splash_screen",
      rokuTv: "RokuTV_splash_screen",
      samsungTv: "Samsung_splash_screen",
      fireTv: "Firetv_splash_screen",
    };

    let hasFiles = false;
    Object.entries(selectedFiles).forEach(([key, file]) => {
      if (file) {
        formData.append(fieldNameMap[key], file);
        hasFiles = true;
      }
    });

    setProcessing(true);
    setShowOverlay(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_Baseurl}/admin/Mobile-App-Setting/splash-screen-store-update`,
        formData,
        { headers }
      );

      if (response.data.status === true) {
        if (hasFiles) {
          const modelName = "MobileAppSetting";
          const formDataAdd = new FormData();
          formDataAdd.append("id", id);
          formDataAdd.append("modelName", modelName);

          Object.entries(selectedFiles).forEach(([key, file]) => {
            if (file) {
              formDataAdd.append("imageFields[]", fieldNameMap[key]);
              formDataAdd.append(fieldNameMap[key], file);
            }
          });

          await fetchRequest({
            method: 'POST',
            url: imageApi,
            data: formDataAdd,
          });
        }

        props.setApiresponsealert(response.data);
        props.setShowalert(true);

        // Refresh data without full page reload
        await fetchData();
        // Clear selected files
        setSelectedFiles({
          splash: null,
          android: null,
          androidTv: null,
          lgTv: null,
          rokuTv: null,
          samsungTv: null,
          fireTv: null,
        });
      } else {
        props.setApiresponsealert(response.data);
        props.setShowalert(true);
      }
    } catch (error) {
      console.error("Update error:", error);
      props.setApiresponsealert({ status: false, message: "Update failed" });
      props.setShowalert(true);
    } finally {
      setProcessing(false);
      setShowOverlay(false);
    }
  };

  const renderMediaSection = (field, label, imageUrl) => (
    <div className="text-start mt-2">
      <p className="theme-text-color mt-0 admin-input-title d-block position-relative">{label}</p>
      <div className="mt-2">
        {loading ? (
          <Response_Loading_processing />
        ) : (
          imageUrl && (
            <img
              src={imageUrl}
              alt="Media"
              className="thumbnails-images w-50 h-50"
            />
          )
        )}
      </div>
      <AdminImageUploadZone
        idAttribute={`splash-${field}`} onChange={(e) => handleFileChange(field, e.target.files[0])}
        selectedFile={selectedFiles[field]} uploadedImage={imageUrl}
        onDelete={() => handleDelete(field)} name={field} accept="image/*"
        icon={<IoImagesOutline />} imguploaded={true} error={formErrors[field]}
      />
    </div>
  );

  return (
    <>
      <AdminBackNavigation path="/mobileappscreen" text="Back" />
      <div className="m-0 p-0">
        <div className="">
          <section className="container-fluid">
            <div className="col-lg-12 row py-3">
              <div className="col-6 col-sm-6 col-lg-6">
                <h5 className="admin-title mb-0 theme-text-color text-md-start">Edit Mobile App Image</h5>
              </div>
              <div className="col-6 col-sm-6 col-lg-6">
                <div className="text-end">
                  <button
                    onClick={handleUpdate}
                    className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-3"
                  >
                    Update Splash
                  </button>
                </div>
              </div>
            </div>

            {showOverlay && <Response_Processing />}

            <div className="row col-lg-12">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="card p-3">
                  <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0">Splash Screen</h5>

                  {renderMediaSection("splash", "Splash Screen(IOS)", editUser?.splash_image_url)}
                  {renderMediaSection("android", "Splash Screen(Android)", editUser?.andriod_splash_image_url)}
                  {renderMediaSection("androidTv", "Splash Screen(Android TV)", editUser?.AndroidTv_splash_screen_url)}
                  {renderMediaSection("lgTv", "Splash Screen(LG TV)", editUser?.LG_splash_screen_url)}
                </div>
              </div>

              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="card p-3">
                  <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0">Splash Screen</h5>

                  {renderMediaSection("rokuTv", "Splash Screen(ROKU TV)", editUser?.RokuTV_splash_screen_url)}
                  {renderMediaSection("samsungTv", "Splash Screen(SAMSUNG TV)", editUser?.Samsung_splash_screen_url)}
                  {renderMediaSection("fireTv", "Splash Screen(FIRE TV)", editUser?.Firetv_splash_screen_url)}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default EditSplashMobileSettings;